import React, { useState, useEffect } from "react";
import styled from "styled-components";

import ProgressBar from "../components/shared/ProgressBar";
import { Hero, FormContainer } from "../components/shared/FormLayout";
import FormHeaderBlock from "../components/shared/FormHeaderBlock";
import { NextButton } from "../components/shared/NextButton";

export default function SignupStep7({ onNext, onBack, formData }) {
  const [agreed, setAgreed] = useState(false);

  const handleSubmit = () => {
    if (!agreed) {
      alert("You must agree to the terms before submitting.");
      return;
    }

    console.log("Form Data Submitted:", formData);
    onNext(formData);
  };

  useEffect(() => {
  const handleEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (agreed) handleSubmit();
    }
  };

  window.addEventListener("keydown", handleEnter);
  return () => window.removeEventListener("keydown", handleEnter);
}, [agreed]);

  return (
    <Hero>
      <FormContainer>
        <FormHeaderBlock title="Agreement of Submission" />
        <ProgressBar currentStep={7} totalSteps={7} />

        <AgreementText>
          By submitting this form, I confirm that the information provided is accurate
          and complete to the best of my knowledge. I agree to BrightWay’s terms of
          service, privacy policy, and community guidelines.
        </AgreementText>

        <CheckboxWrapper>
          <input
            type="checkbox"
            checked={agreed}
            onChange={() => setAgreed(!agreed)}
            id="agreement"
          />
          <label htmlFor="agreement">I agree to the terms and conditions.</label>
        </CheckboxWrapper>

        <AlignedButtonWrapper>
          <NextButton disabled={!agreed} onClick={handleSubmit}>
            Submit
          </NextButton>
          {/* <BackButton onClick={onBack}>Back</BackButton> */}
        </AlignedButtonWrapper>
      </FormContainer>
    </Hero>
  );
}

// Styled Components

const AgreementText = styled.p`
  font-size: 0.95rem;
  color: #000;
  padding: 1rem;
  margin-bottom: 1rem;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  line-height: 1.5;
  max-width: 350px;
  font-weight: 600;
  text-align: center;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #000;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
  max-width: 350px;
  font-weight: 600;

  input {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  label {
    cursor: pointer;
  }
`;

const AlignedButtonWrapper = styled.div`
  width: 100%;
  max-width: 350px;
`;
